import LabeledField from '../../components/LabeledField';
import { useInputStyles } from './Input.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Input = ({
  name,
  value,
  label,
  labelLayout,
  inputType,
  placeholder,
  required,
  isDisabled = false,
  onChange
}) => {
  const {
    inputStyle
  } = useInputStyles({
    isDisabled
  });
  const inputId = `input-${name}`;
  const handleChange = e => {
    onChange(name, e.target.value);
  };
  return /*#__PURE__*/_jsx(LabeledField, {
    htmlFor: inputId,
    label: label,
    required: required,
    labelLayout: labelLayout,
    children: /*#__PURE__*/_jsx("input", {
      id: inputId,
      type: inputType !== null && inputType !== void 0 ? inputType : 'text',
      value: value,
      placeholder: placeholder,
      required: required,
      disabled: isDisabled,
      onChange: handleChange,
      style: inputStyle
    })
  });
};
export default Input;